import React from 'react';
import { SITE_NAME } from '../../data/siteInfo';

const Logo = ({ className = '', iconOnly = false, variant = 'default' }) => {
  const isLight = variant === 'light';
  const primary = isLight ? '#FFFFFF' : '#8B1538';
  const secondary = isLight ? '#D4AF37' : '#2D2D2D';
  const nestAccent = isLight ? '#F5D76E' : '#C4A052';
  const balloonPink = isLight ? '#F5C6CB' : '#E8B4B8';
  const balloonGold = '#D4AF37';
  const stringColor = isLight ? '#ccc' : '#666';

  return (
    <svg
      viewBox={iconOnly ? '0 0 48 48' : '0 0 190 48'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={SITE_NAME}
      className={`${iconOnly ? 'h-10 w-10' : 'h-10 sm:h-12 w-auto'} ${className}`}
    >
      <g transform={iconOnly ? 'translate(4, 4) scale(0.85)' : 'translate(0, 2)'}>
        <ellipse cx="22" cy="36" rx="17" ry="5" fill={primary} opacity={isLight ? 0.2 : 0.12} />
        <path
          d="M8 30C8 30 12 17 22 13C32 17 36 30 36 30"
          stroke={primary}
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M10 28C14 23 18 21 22 21C26 21 30 23 34 28"
          stroke={nestAccent}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line x1="22" y1="13" x2="22" y2="7" stroke={stringColor} strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="16" cy="9" r="4.5" fill={primary} />
        <circle cx="28" cy="11" r="4" fill={balloonGold} />
        <circle cx="22" cy="5.5" r="3.5" fill={balloonPink} />
        <circle cx="38" cy="16" r="1.2" fill={balloonGold} />
        <circle cx="6" cy="18" r="1" fill={balloonPink} />
      </g>

      {!iconOnly && (
        <text
          x="52"
          y="32"
          fontFamily="system-ui, -apple-system, Segoe UI, sans-serif"
          fontSize="22"
          fontWeight="700"
        >
          <tspan fill={primary}>Party</tspan>
          <tspan fill={isLight ? '#FFFFFF' : secondary}>Nestt</tspan>
        </text>
      )}
    </svg>
  );
};

export default Logo;
